
export default {
  data: () => ({
    loading: false,
    starters: [],
    loadingText: null,
    disableAfter: 0,
  }),
  methods: {
    start(callerId = null, caller = null, loadingText = null, force = false) {
      // console.log(`loading.start called for [${callerId}].[${caller}] with text [${loadingText}]`)
      if (!this.loading) {
        if (force) {
          this.loading = true
          this.disableAfter = Date.now() + 1 * 1000
        } else {
          setTimeout(() => {
            if (this.starters.length === 0 || this.loading) {
              return
            }

            this.loading = true
            this.disableAfter = Date.now() + 1 * 1000
          }, 200)
        }
      }
      this.starters.unshift({ callerId, loadingText })
      if (loadingText) {
        this.loadingText = loadingText
      }
    },
    finish(callerId = null, caller = null, loadingText = null) {
      const timeDif = this.disableAfter - Date.now()
      if (timeDif > 0) {
        setTimeout(() => this.finishInternal(callerId, caller, loadingText), timeDif)
        return
      }
      this.finishInternal(callerId, caller, loadingText)
    },
    finishInternal(callerId = null, caller = null, loadingText = null) {
      // console.log(`loading.finish called for [${callerId}].[${caller}] with text [${loadingText}]`)
      const idx = this.starters.findIndex((x) => x.callerId === callerId && x.loadingText === loadingText)
      this.starters.splice(idx, 1)
      this.loadingText = null
      this.loading = this.starters.length !== 0

      if (!this.loading) {
        return
      }

      const loadingTextIdx = this.starters.findIndex((x) => x.loadingText)

      if (loadingTextIdx < 0) {
        return
      }

      this.loadingText = this.starters[loadingTextIdx].loadingText
    },
  },
}
